<template>
  <BaseField
    ref="field"
    class="field-sum"
    v-bind="attributes"
    v-on="$listeners"
  >
    <input
      v-if="prettyValue"
      type="text"
      :value="prettyValue"
      readonly
      tabindex="-1"
      class="field__el field-sum__value"
      slot="container"
    />
  </BaseField>
</template>

<script>
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldSum',
  inheritAttrs: false,
  components: {
    BaseField,
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
  },
  staticData: () => ({
    mask: {
      mask: Number,
      scale: 2,
      signed: false,
      thousandsSeparator: '',
      padFractionalZeros: false,
      normalizeZeros: true,
      radix: '.',
      mapToRadix: [','],
      max: 100000000,
    },
  }),
  computed: {
    attributes() {
      return {
        type: 'tel',
        label: this.$t('fields.sumLabel'),
        errorMessage: this.$t('fields.sumError', {
          min: this.min,
        }),
        placeholder: this.$t('fields.sumPlaceholder'),
        maskOptions: this.mask,
        completeValidator: this.checkMinValue,
        hasClearButton: false,
        ...this.$attrs,
      };
    },
    prettyValue() {
      if (!this.$attrs.value) return '';
      return this.$options.filters.sum(this.$attrs.value, true);
    },
  },
  methods: {
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
    checkMinValue() {
      return Number(this.$attrs.value) >= this.min;
    },
  },
};
</script>

<style lang="stylus">
.field-sum

  &__value
    abs top left
    width 100%
    height 100%
    pointer-events none
    opacity 1

  &.field_focused
    & ^[0]__value
      opacity 0
</style>
